import React, { Children } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import css from './LinksList.module.css'

const LinksList = ({ children, isFullWidth }) => (
  <ul className={classnames(css.wrapper, { [css.isFullWidth]: isFullWidth })}>
    {
      Children.map(children, (child) => (
        <li className={css.item}>{child}</li>
      ))
    }
  </ul>
)

LinksList.propTypes = {
  children: PropTypes.node.isRequired,
  isFullWidth: PropTypes.bool,
}

LinksList.defaultProps = {
  isFullWidth: false,
}

export { LinksList }
